import { render } from "./Edit.vue?vue&type=template&id=b5565940&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=b5565940&scoped=true&lang=css"

import exportComponent from "/Users/home/Projects/creelayer/mosquito/mosquito.web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5565940"]])

export default __exports__